import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { TrendingUp } from "lucide-react";

export default function LiveTicker() {
  const [quotes, setQuotes] = useState(null);

  useEffect(() => {
    let timer;
    const load = () => api.get("/quotes").then((r) => setQuotes(r.data)).catch(() => {});
    load();
    timer = setInterval(load, 60000);
    return () => clearInterval(timer);
  }, []);

  if (!quotes) return null;
  const m = quotes.manual || {};
  const items = [
    { label: "Oro 24kt", value: m.gold_24kt, id: "live-ticker-24kt" },
    { label: "Oro 22kt", value: m.gold_22kt, id: "live-ticker-22kt" },
    { label: "Oro 21kt", value: m.gold_21kt, id: "live-ticker-21kt" },
    { label: "Oro 18kt", value: m.gold_18kt, id: "live-ticker-18kt" },
    { label: "Oro 14kt", value: m.gold_14kt, id: "live-ticker-14kt" },
    { label: "Oro 9kt", value: m.gold_9kt, id: "live-ticker-9kt" },
    { label: "Argento 925", value: m.silver_925, id: "live-ticker-silver" },
  ];

  const row = (key) => (
    <div className="flex items-center gap-12 px-4" key={key}>
      {items.map((it) => (
        <div key={`${key}-${it.id}`} data-testid={it.id} className="flex items-center gap-3 whitespace-nowrap">
          <span className="text-[0.65rem] uppercase tracking-[0.25em] text-white/50">{it.label}</span>
          <span className="gold-text font-serif text-xl">€ {Number(it.value).toFixed(2)}</span>
          <span className="text-[0.65rem] text-white/40">/g</span>
        </div>
      ))}
    </div>
  );

  return (
    <div data-testid="live-ticker-bar" className="relative bg-[#060f1f]/95 backdrop-blur-xl border-y border-[var(--gold)]/20 py-3 overflow-hidden">
      <div className="absolute left-0 top-0 bottom-0 z-10 flex items-center gap-2 bg-gradient-to-r from-[#060f1f] via-[#060f1f] to-transparent pl-6 pr-12">
        <TrendingUp size={14} className="text-[var(--gold)]" />
        <span className="text-[0.6rem] uppercase tracking-[0.3em] text-[var(--gold)] font-medium">Live</span>
      </div>
      <div className="ticker-track">
        {row("a")}
        {row("b")}
      </div>
    </div>
  );
}
